module.exports = __webpack_public_path__ + "static/media/55_000031.0f233d17.jpg";